import React, {Component, useState} from 'react';
import { Button, Container, Row, Col, FormControl, FormLabel, Alert } from 'react-bootstrap';
import SupplierService from "./services/supplier.service";
import { Navigate } from 'react-router-dom';
import { IoIosArrowBack } from "react-icons/io";

var newDate = new Date()
var gtDate = newDate.getDate().toString().padStart(2,'0') + '-' + (newDate.getMonth()+1).toString().padStart(2,'0') + '-' + newDate.getFullYear()

class NewSupplier extends Component {  

  constructor(props) {
    super(props);
    this.onChangeSupplierName = this.onChangeSupplierName.bind(this);
    this.onChangeContactPerson = this.onChangeContactPerson.bind(this);
    this.onChangeContactPhone = this.onChangeContactPhone.bind(this);
    this.onChangeContactEmail = this.onChangeContactEmail.bind(this);
    this.saveSupplier = this.saveSupplier.bind(this);
    this.retrieveSuppliers = this.retrieveSuppliers.bind(this);
    this.refreshList = this.refreshList.bind(this);    
    this.handleValidations = this.handleValidations.bind(this);
    this.goToSuppliersList = this.goToSuppliersList.bind(this);

    this.state = {
      id: null,
      suppliername: "",
      contactperson: "",
      contactphone: "",
      contactemail: "",
      submitted: false,
      suppliers: [],
      currentSupplier: null,
      currentIndex: -1,  
      showerror: false,
      errmessage:'',   
      showsuccess: false,
      succmessage: ''
    };
  }

  goToSuppliersList() {
    window.location.assign('/suppliers');
  }

  handleValidations() {
    if (this.state.suppliername.length==0 || this.state.contactperson.length==0) {
      this.setState({errmessage:'Fields can not be empty.'})
      this.setState({showerror:true})
      return;
    }
    if (this.state.contactemail) {
      if (!/\S+@\S+\.\S+/.test(this.state.contactemail)) {
        this.setState({errmessage:'Email is invalid.'})
        this.setState({showerror:true})
        return;
      }      
    }
    this.saveSupplier();
  } 


  retrieveSuppliers() {
    SupplierService.getAll()
      .then(response => {
        this.setState({
            suppliers: response.data
        });
        console.log(response.data);
      })
      .catch(e => {
        console.log(e);
      });
  }

  refreshList() {
    this.retrieveSuppliers();
    this.setState({
        currentSupplier: null,
        currentIndex: -1
    });
  }

  onChangeSupplierName(e) {
    this.setState({
        suppliername: e.target.value
    });
  }

  onChangeContactPerson(e) {
    this.setState({
        contactperson: e.target.value
    });
  }

  onChangeContactPhone(e) {
    this.setState({
        contactphone: e.target.value
    });
  }  

  onChangeContactEmail(e) {
    this.setState({
        contactemail: e.target.value
    });
  }   

  saveSupplier() {
    var data = {
        suppliername: this.state.suppliername,
        contactperson: this.state.contactperson,
        contactphone: this.state.contactphone,
        contactemail: this.state.contactemail
    };

    SupplierService.create(data)
      .then(response => {
        this.setState({
          // id: response.data.id,
          suppliername: response.data.suppliername,
          contactperson: response.data.suppliercontactperson,
          contactphone: response.data.suppliercontactphone,
          contactemail: response.data.suppliercontactemail,
          submitted: true          
        });
        this.setState({errmessage:''});
        this.setState({showerror:false});
        this.setState({succmessage:'Supplier has been created. Redirecting to supplier list...'});
        this.setState({showsuccess:true});           
        this.refreshList();
        console.log(response.data);
      })
      .catch(e => {
        this.setState({errmessage:e.response?e.response.data.message:e.message})       
        this.setState({showerror:true})
        this.setState({succmessage:''})
        this.setState({showsuccess:false}) 
      });
  }

  render() {
    return (
      <>
      <Container>
        <Row className='mb-2'>
          <FormLabel style={{fontSize:"0.8em",textAlign:"right"}}>Current Date: {gtDate}</FormLabel>
          <hr/>
          <h1 className='mb-4' style={{width: "100%", textAlign: "center", marginLeft: "0%", color: "green" }}>NEW SUPPLIER</h1>
          <Col className='col-md-3' sm={8}>
            <FormLabel className='mb-2'>Supplier Name:</FormLabel>       
            <FormControl style={{maxWidth:"300px"}} type="text" name="suppliername" id="suppliername" onChange={this.onChangeSupplierName}></FormControl>
          </Col>

          <Col className='col-md-3' sm={8}>
            <FormLabel className='mb-2'>Contact Person:</FormLabel>       
            <FormControl style={{maxWidth:"300px"}} type="text" name="contactperson" id="contactperson" onChange={this.onChangeContactPerson}></FormControl>
          </Col>          

          <Col className='col-md-3' sm={8}>
            <FormLabel className='mb-2'>Phone:</FormLabel>       
            <FormControl style={{maxWidth:"300px"}} type="number" name="contactphone" id="contactphone" onChange={this.onChangeContactPhone}></FormControl>
          </Col>  

          <Col className='col-md-3' sm={8}>
            <FormLabel className='mb-2'>Email:</FormLabel>       
            <FormControl style={{maxWidth:"300px"}} type="text" name="contactemail" id="contactemail" onChange={this.onChangeContactEmail}></FormControl>
          </Col>  

        </Row>
        <hr/>
        <Row className='mb-2'>
          <Col className='col-md-3'>
            <Button id='saveItem' onClick={this.handleValidations}>Save Supplier</Button>            
            <Button className='m-2' id='backToSuppliersList' onClick={this.goToSuppliersList}><IoIosArrowBack/></Button>            
          </Col>
        </Row>  
        {this.state.showerror && (
          <Alert variant="danger" onClose={() => this.setState({showerror:false})} dismissible>
            <Alert.Heading>Error</Alert.Heading>
            <p>{this.state.errmessage}</p>
          </Alert>      
        )}
        {this.state.showsuccess && (
          <Alert variant="success" onClose={() => this.setState({showsuccess:false})} dismissible>
            <Alert.Heading>Done</Alert.Heading>
            <p>{this.state.succmessage}</p>
          </Alert>      
        )}     
         { this.state.submitted ? (<Navigate push to="/suppliers"/>) : null }                                     
      </Container>
      </>
    )      
  }
}

export default NewSupplier;